<template>
    <v-container id="dashboard" fluid>
      <v-row>
        <v-col cols="12">
          <div class="d-flex justify-center">
            <v-subheader class="display-1 font-weight-bold has-border"
              >AMS Scheduling</v-subheader
            >
          </div>
        </v-col>
        <!-- <v-col cols="12">
          <v-row>
            <v-col cols="12">
              <v-row> -->
                <!-- <v-col cols="12" md="2"></v-col> -->
                <v-col cols="12" sm="6" md="4" v-if="isSuperAdmin === true">

                  <router-link
                    :to="{
                      name: 'roleConfiguration',
                    }"
                    title="Role Configuration"
                  >
                    <clickable-card
                      goIcon="mdi-arrow-top-right"
                      icon="mdi-account-tie"
                      color="accent"
                      title="Role Configuration"
                    >
                    </clickable-card>
                  </router-link>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="isSuperAdmin === true || center === true || AMSHolidayUpload === true" >

                  <router-link
                    :to="{
                      name: 'uploadAndViewHoliday',

                    }"

                  >
                    <clickable-card
                      goIcon="mdi-arrow-top-right"
                      icon="mdi-file-document"
                      color="info"
                      title="Upload & View Holidays"
                    >
                    </clickable-card>
                  </router-link>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="isSuperAdmin === true || AMS_ZonalManager === true || AMS_CycleConfiguration === true || AMS_WeightageModification === true">
                   <router-link
                    :to="{
                      name: 'amsConfiguration',
                      // params: {
                      //   ticketstatus: 'closed',
                      //   franchiseeID: franchiseeID
                      // }
                    }"
                    title="AMS Configuration"
                  >
                  <clickable-card
                      goIcon="mdi-arrow-top-right"
                      icon="mdi-email-check"
                      color="success"
                      title="AMS Configuration"
                    >
                    </clickable-card>
                  </router-link>
                </v-col>
              <!-- </v-row>
            </v-col>
          </v-row>
        </v-col> -->
        <!-- <v-col cols="12">
          <v-row>
            <v-col cols="12">
              <v-row> -->
                <!-- <v-col cols="12" md="2"></v-col> -->
                <v-col cols="12" sm="6" md="4" v-if="AMS_ZonalManager === true || isSuperAdmin === true">

                  <router-link
                    :to="{
                      name: 'allocateCenter',
                    }"
                    title="Allocate Center"
                  >
                    <clickable-card
                      goIcon="mdi-arrow-top-right"
                      icon="mdi-account-group"
                      color="pink"
                      title="Allocate Centers"
                    >
                    </clickable-card>
                  </router-link>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="AMS_AreaManager === true || isSuperAdmin === true">

                  <router-link
                    :to="{
                      name: 'myCenters',
                    }"
                    title="My Centers"
                  >
                    <clickable-card
                      goIcon="mdi-arrow-top-right"
                      icon="mdi-account-multiple"
                      color="warning"
                      title="My Centers"
                    >
                    </clickable-card>
                  </router-link>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="AMS_AreaManager === true || isSuperAdmin === true">
                   <router-link
                    :to="{
                      name: 'createViewSchedule',
                    }"
                    title="Create View Schedule"
                  >
                  <clickable-card
                      goIcon="mdi-arrow-top-right"
                      icon="mdi-file-document"
                      color="success"
                      title="Create / View Schedule"
                    >
                    </clickable-card>
                  </router-link>
                </v-col>
              <!-- </v-row>
            </v-col>
          </v-row>
        </v-col> -->
        <!-- <v-col cols="12">
          <v-row>
            <v-col cols="12">
              <v-row> -->
                <!-- <v-col cols="12" md="2"></v-col> -->
                <v-col cols="12" sm="6" md="4" v-if="AMS_ZonalManager === true || isSuperAdmin === true">

                  <router-link
                    :to="{
                      name: 'viewApprovedSchedule',
                    }"
                    title="View / Approved Schedules"
                  >
                    <clickable-card
                      goIcon="mdi-arrow-top-right"
                      icon="mdi-file-document"
                      color="error"
                      title="View / Approved Schedules"
                    >
                    </clickable-card>
                  </router-link>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="AMS_ZonalManager === true || AMS_AreaManager === true || isSuperAdmin === true" >

                  <router-link
                    :to="{
                      name: 'centerCategory',
                    }"
                    title="Center Category"
                  >
                    <clickable-card
                      goIcon="mdi-arrow-top-right"
                      icon="mdi-school"
                      color="accent"
                      title="Center Category"
                    >
                    </clickable-card>
                  </router-link>
                </v-col>
              <!-- </v-row>
            </v-col>
          </v-row>
        </v-col> -->
      </v-row>
    </v-container>
</template>

<script>
// import Utils from '@/utils'
import ClickableCard from '@/components/template/ClickableCard'
import stores from '@/stores'
// import DataCard from '@/components/template/DataCard'

export default {
  name: 'amsSchedulingDashboard',
  components: { ClickableCard },
  data () {
    return {
      isSuperAdmin: false,
      center: false,
      AMS_ZonalManager: false,
      userEmail: '',
      AMS_AreaManager: false,
      AMS_CycleConfiguration: false,
      AMS_WeightageModification: false,
      AMSHolidayUpload: false
    }
  },
  created: async function () {
    let userStore = stores.user
    this.isSuperAdmin = userStore.ACL.superAdmin
    this.userEmail = userStore.userInfo.email
    if (this.isSuperAdmin === false) {
      for (const item of userStore.roles) {
        if (item.role === 'FRANCHISEE_USER_1') {
          this.center = true
        }
        if (item.role === 'AMS_ZonalManager') {
          this.AMS_ZonalManager = true
        }
        if (item.role === 'AMS_AreaManager') {
          this.AMS_AreaManager = true
        }
        if (item.role === 'AMSCycleConfiguration') {
          this.AMS_CycleConfiguration = true
        }
        if (item.role === 'AMSWeightageModification') {
          this.AMS_WeightageModification = true
        }
        if (item.role === 'AMSHolidayUpload') {
          this.AMSHolidayUpload = true
        }
      }
    }
  },
  methods: {
    handleCardClick () {
      // Handle the click event here

    }
  }
}

</script>
